// src/components/BlogPost.jsx

import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'

export default function BlogPost() {
  const { slug } = useParams()
  const [meta, setMeta] = useState(null)
  const [content, setContent] = useState('')

  useEffect(() => {
    // 1) load metadata
    fetch('/postsIndex.json')
      .then(r => r.json())
      .then(posts => setMeta(posts.find(p => p.slug === slug)))
      .catch(console.error)

    // 2) load the Markdown body
    fetch(`/posts/${slug}.md`)
      .then(r => r.text())
      .then(setContent)
      .catch(() => setContent('# 404\nPost not found'))
  }, [slug])

  if (!meta) return <p className="p-6 text-center">Loading…</p>

  return (
    <article className="max-w-3xl mx-auto my-12 bg-white rounded-lg overflow-hidden shadow">
      {/* Header image */}
      {meta.cover_image_url && (
        <img
          src={meta.cover_image_url}
          alt={meta.title}
          className="w-full h-64 object-cover"
        />
      )}

      {/* Title & date */}
      <header className="px-6 py-8 text-center">
        <h1 className="text-4xl font-bold mb-2">{meta.title}</h1>
        <time className="text-gray-500">
          {new Date(meta.date).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
        </time>
      </header>

      {/* Markdown content */}
      <div className="px-6 pb-12 prose prose-lg prose-orange mx-auto">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>

      {/* Back link */}
      <div className="px-6 pb-8 text-center">
        <Link to="/blog" className="text-orange-600 hover:underline">
          ← Back to Blog
        </Link>
      </div>
    </article>
  )
}